
import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const Bell = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.725 15.75C7.85054 15.9783 8.03509 16.1688 8.25937 16.3014C8.48365 16.434 8.73943 16.504 9 16.504C9.26057 16.504 9.51635 16.434 9.74063 16.3014C9.96491 16.1688 10.1495 15.9783 10.275 15.75M4.5 6C4.5 4.80653 4.97411 3.66193 5.81802 2.81802C6.66193 1.97411 7.80653 1.5 9 1.5C10.1935 1.5 11.3381 1.97411 12.182 2.81802C13.0259 3.66193 13.5 4.80653 13.5 6C13.5 11.25 15.75 12.75 15.75 12.75H2.25C2.25 12.75 4.5 11.25 4.5 6Z"
          stroke={theme.palette.text.primary}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Bell;
